var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aff3986737"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "868ffa84c5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 0.730469 L 23.09375 0.730469 L 23.09375 28.308594 L 7 28.308594 Z M 7 0.730469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "24acfbd4c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.539062 5 L 12 5 L 12 11 L 6.539062 11 Z M 6.539062 5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aff3986737)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdfbf9",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#868ffa84c5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 10.167969 14.839844 L 11.679688 17.839844 C 9.789062 17.222656 8.78125 16.300781 10.167969 14.839844 Z M 22.960938 26.617188 L 17.578125 16.453125 C 17.570312 16.441406 17.5625 16.433594 17.554688 16.417969 L 14.867188 11.070312 C 14.96875 9.417969 14.996094 3.433594 10.398438 0.871094 C 9.847656 0.566406 9.15625 0.769531 8.855469 1.328125 C 8.554688 1.882812 8.753906 2.582031 9.304688 2.886719 C 12.621094 4.734375 12.671875 9.421875 12.605469 10.824219 C 12.359375 10.953125 10.03125 12.128906 9.835938 12.304688 C 7.890625 12.707031 4.480469 18.34375 11.476562 20.171875 L 10.429688 21.140625 C 10.230469 21.328125 10.097656 21.585938 10.070312 21.863281 L 9.503906 27.035156 C 9.433594 27.664062 9.882812 28.230469 10.503906 28.300781 C 11.125 28.375 11.6875 27.917969 11.757812 27.285156 L 12.273438 22.546875 L 15.753906 19.320312 L 16.359375 19.007812 L 20.964844 27.703125 C 21.257812 28.261719 21.945312 28.472656 22.5 28.171875 C 23.050781 27.871094 23.257812 27.175781 22.960938 26.617188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#24acfbd4c6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#040606",
    d: "M 11.195312 8.199219 C 11.195312 9.46875 10.183594 10.5 8.929688 10.5 C 7.675781 10.5 6.664062 9.46875 6.664062 8.199219 C 6.664062 6.929688 7.675781 5.902344 8.929688 5.902344 C 10.183594 5.902344 11.195312 6.929688 11.195312 8.199219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovement);
export default __webpack_public_path__ + "static/media/movement.530578ad6e463530522d881b41741852.svg";
export { ForwardRef as ReactComponent };